import { useState, useEffect } from 'react';
import { TenantInfo } from '../types';
import { apiService } from '../services/api';

export function useTenant() {
  const [tenantInfo, setTenantInfo] = useState<TenantInfo | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTenantInfo = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await apiService.getTenantInfo();
        
        if (response.success) {
          setTenantInfo(response.data);
        } else {
          setError(response.error?.message || 'Failed to fetch tenant info');
        }
      } catch (err) {
        setError('Network error while fetching tenant info');
      } finally {
        setLoading(false);
      }
    };

    fetchTenantInfo();
  }, []);

  const isCustomDomain = tenantInfo?.isCustomDomain || false;
  const tenantName = tenantInfo?.name || 'Charity Auctions';
  const tenantLogo = tenantInfo?.logoImageUrl;
  const tenantEntryVideo = tenantInfo?.entryVideoUrl;

  return {
    tenantInfo,
    loading,
    error,
    isCustomDomain,
    tenantName,
    tenantLogo,
    tenantEntryVideo,
  };
}
